// extracted by mini-css-extract-plugin
export default {"container":"CycleRecords_container__2KlzA","content":"CycleRecords_content__I2hrX","title":"CycleRecords_title__HIyDB","actions":"CycleRecords_actions__5u0p4"};